function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "d1l88cizka",
  width: "175%",
  height: "152.5%",
  x: "-37.5%",
  y: "-26.2%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.55505548 0 0 0 0 0.514431088 0 0 0 0 0.514431088 0 0 0 0.5 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("path", {
  id: "lc39aa3osb",
  d: "M23.971 15.978h-1.135V9.083C22.836 4.074 18.763 0 13.755 0 8.746 0 4.672 4.074 4.672 9.083v6.895H3.537C1.584 15.978 0 17.56 0 19.515V35.92c0 1.954 1.584 3.537 3.537 3.537H23.97c1.954 0 3.538-1.583 3.538-3.537V19.515c0-1.954-1.584-3.537-3.538-3.537zM13.754 21.67c1.775 0 3.213 1.439 3.213 3.213 0 1.103-.556 2.076-1.403 2.655v4.416c0 1-.81 1.81-1.81 1.81-.999 0-1.809-.81-1.809-1.81v-4.416c-.847-.578-1.403-1.552-1.403-2.655 0-1.775 1.438-3.213 3.212-3.213zm0-18.493c3.256 0 5.905 2.649 5.905 5.905v6.895H7.849V9.083c0-3.256 2.65-5.905 5.906-5.905z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#d1l88cizka)",
  transform: "translate(-545.000000, -243.000000) translate(509.000000, 215.000000) translate(44.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#523C00",
  fillRule: "nonzero",
  d: "M10.526 21.053H18.947V33.685H10.526z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "tabwke0hhc",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lc39aa3osb"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#F7B500",
  fillRule: "nonzero",
  xlinkHref: "#lc39aa3osb"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-12.684 26.316h29.579c.552 0 1 .448 1 1v4.316c0 .552-.448 1-1 1h-29.58c-.551 0-1-.448-1-1v-4.316c0-.552.449-1 1-1z",
  mask: "url(#tabwke0hhc)",
  opacity: 0.262,
  transform: "translate(2.105263, 29.473684) rotate(90.000000) translate(-2.105263, -29.473684)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12.908 23.882h25.5c.552 0 1 .447 1 1v3c0 .552-.448 1-1 1h-25.5c-.552 0-1-.448-1-1v-3c0-.553.448-1 1-1z",
  mask: "url(#tabwke0hhc)",
  opacity: 0.262,
  transform: "translate(25.657895, 26.381579) rotate(90.000000) translate(-25.657895, -26.381579)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 31.579,
  height: 4.211,
  x: -2.105,
  y: 35.789,
  fill: "#DAAD33",
  mask: "url(#tabwke0hhc)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#787878",
  d: "M-10.079 -12.578H31.761000000000003V16.022000000000002H-10.079z",
  mask: "url(#tabwke0hhc)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.976 2.5h9.348c1.477 0 2.68 1.186 2.7 2.662l.132 9.442c.011.774-.607 1.41-1.381 1.42-.039.001-.078 0-.116-.002 0 0-13.28.112-13.28-.044 0-.093-.034-3.677-.103-10.752C6.262 3.736 7.46 2.515 8.95 2.5h.026z",
  mask: "url(#tabwke0hhc)",
  opacity: 0.433
}))))));

var SvgIconLock = function SvgIconLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 56,
    viewBox: "0 0 44 56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-lock.921765a8.svg";
export { ForwardRef as ReactComponent };